import { requestGet, requestPost } from '@/common/request';

export default {
  // 获取资源位接口（权限范围内的）
  async resourceListOwnResourceState(data) {
    return await requestGet('/resource/listOwnResourceState', data);
  },

  // 资源位列表接口
  async getResourceState(query) {
    return await requestGet('/resourceState/query', query);
  },

  async cmsResourceAddResource(query) {
    return await requestPost('/cmsResource/addResource', query);
  },

  async cmsResourceUpdateResource(query) {
    return await requestPost('/cmsResource/updateResource', query);
  },

  async cmsResourceListCmsResource(query) {
    return await requestGet('/cmsResource/listCmsResource', query);
  },

  // 待审核列表数据查询接口
  async checkReadServicequeryForHomeFloorList(data) {
    return await requestPost('/generic/yxCheckReadService/queryForHomeFloorList', data);
  },

  // 通过资源位编号查看信息
  async resourceStateGetByResourceStateCode(data) {
    return await requestGet('/resourceState/getByResourceStateCode', data);
  },

  // 审核通过接口
  async checkWriteServiceCheckPass(data) {
    return await requestPost('/generic/yxCheckWriteService/checkPass', data);
  },
  // 审核驳回
  async checkWriteServiceCheckReject(data) {
    return await requestPost('/generic/yxCheckWriteService/checkReject', data);
  },
  // 根据报名ID拉取报名详情接口
  async applyReadServicequeryForList(data) {
    return await requestPost('/generic/yxCheckReadService/queryForHomeFloorList', data);
  },
  // 资源申请列表
  async yxApplyReadServicequeryForList(data) {
    return await requestPost('/generic/yxApplyReadService/queryForList', data);
  },
  // 待报名活动列表
  async genericActivityReadServicequeryForList(data) {
    return await requestPost('/generic/yxActivityReadService/queryForList', data);
  },

  async validateErp(erps) {
    // return await requestGet(origin + '/acore/pin/vaild', { erps })
    return await requestGet('/pin/valid', { erps });
  },
};
